import React, { useState, useEffect, useRef } from 'react';
import { Link as ReactRouterLink, useHistory } from 'react-router-dom';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Link from '@mui/material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import GroupsIcon from '@mui/icons-material/Groups';
import BoltIcon from '@mui/icons-material/Bolt';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import Tooltip           from '@mui/material/Tooltip';
import ToggleButton      from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Card from 'components/Card/Card.js';
import BarChart from 'components/Charts/BarChart';
import moneyFormat from 'helpers/moneyFormat';
import timeFormat from 'helpers/timeFormat';

const fmtM = (val) => {
  if (val == null || isNaN(Number(val))) return '0';
  const n = Number(val);
  if (Math.abs(n) >= 1e6)
    return `$${(n / 1e6).toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}M`;
  return moneyFormat(n);
};

// Formato de kW: millones con sufijo "M kWh" si corresponde.
const fmtKw = (val) => {
  if (val == null || isNaN(Number(val))) return '0';
  const n = Number(val);
  if (Math.abs(n) >= 1e6)
    return `${(n / 1e6).toLocaleString('es-AR', { maximumFractionDigits: 1 })}M kWh`;
  return `${n.toLocaleString('es-AR', { maximumFractionDigits: 0 })} kWh`;
};

const fmtNum = (val) =>
  val == null || isNaN(Number(val)) ? '0' : Number(val).toLocaleString('es-AR');

// Variables
const monthNames = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];
const getNextMonthName = () => {
  const today = new Date();
  const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
  return monthNames[nextMonth.getMonth()];
};

const getMonthName = () => {
  const today = new Date();
  const currentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  return monthNames[currentMonth.getMonth()];
};

const getPreviousMonthName = () => {
  const today = new Date();
  const prevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  return monthNames[prevMonth.getMonth()];
};

const iconGreen = '#8ebf63';
const iconGrey  = '#9e9e9e';

export default function Dashboard() {
  const history = useHistory();
  //#region Total Suministros Energia
  function loadTotSE(){
    try {
       fetch(`${process.env.REACT_APP_API_URL}/querysext/13`,
          {method: "post",
          headers: { "Content-Type": "application/json" ,
                    "Authorization":  localStorage.getItem('token'),
                    },
          })
          .then(res => res.json())
          .then(data =>setTotSE(data));
    } catch (error) {
      console.error('Error al obtener datos:', err.message);
    }
  };
  const [TotSE, setTotSE] = useState([]);
  useEffect(()=>{loadTotSE()},[]);
  //#endregion
  //#region Total Suministros Sepelios
  function loadTotSS(){
    try {
       fetch(`${process.env.REACT_APP_API_URL}/querysext/14`,
          {method: "post",
          headers: { "Content-Type": "application/json" ,
                    "Authorization":  localStorage.getItem('token'),
                    },
          })
          .then(res => res.json())
          .then(data =>setTotSS(data));
    } catch (error) {
      console.error('Error al obtener datos:', err.message);
    }
  };
  const [TotSS, setTotSS] = useState([]);
  useEffect(()=>{loadTotSS()},[]);
  //#endregion
  //#region Total Socios
  function loadTotSocios(){
    try {
       fetch(`${process.env.REACT_APP_API_URL}/querysext/12`,
          {method: "post",
          headers: { "Content-Type": "application/json" ,
                    "Authorization":  localStorage.getItem('token'),
                    },
          })
          .then(res => res.json())
          .then(data =>setTotSoc(data));
    } catch (error) {
      console.error('Error al obtener datos:', err.message);
    }
  };
  const [TotSoc, setTotSoc] = useState([]);
  useEffect(()=>{loadTotSocios()},[]);
  //#endregion
  //#region Total Clientes
  function loadTotClientes(){
    try {
       fetch(`${process.env.REACT_APP_API_URL}/querysext/11`,
          {method: "post",
          headers: { "Content-Type": "application/json" ,
                    "Authorization":  localStorage.getItem('token'),
                    },
          })
          .then(res => res.json())
          .then(data =>setTotCli(data));
    } catch (error) {
      console.error('Error al obtener datos:', err.message);
    }
  };
  const [TotCli, setTotCli] = useState([]);
  useEffect(()=>{loadTotClientes()},[]);
  //#endregion
  //#region Total Deuda
  const [filtroDeuda,   setFiltroDeuda]   = useState('periodo');
  const [impDeuda,      setImpDeuda]      = useState(null);
  const [loadingDeuda,  setLoadingDeuda]  = useState(true);

  useEffect(() => {
    setLoadingDeuda(true);
    fetch(
      `${process.env.REACT_APP_API_URL}/deudapor-tipo/totales?filtroFecha=${filtroDeuda}`,
      { headers: { 'Authorization': localStorage.getItem('token') } }
    )
      .then(res => res.json())
      .then(json => {
        const total = (json.datos || []).reduce((s, t) => s + (t.gerencial || 0), 0);
        setImpDeuda(total);
      })
      .catch(() => setImpDeuda(0))
      .finally(() => setLoadingDeuda(false));
  }, [filtroDeuda]);
  //#endregion
  //#region Total Pagos
  function loadImpPagos(){
    try {
       fetch(`${process.env.REACT_APP_API_URL}/querysext/9`,
          {method: "post",
          headers: { "Content-Type": "application/json" ,
                    "Authorization":  localStorage.getItem('token'),
                    },
          })
          .then(res => res.json())
          .then(data =>setImpPagos(data));
    } catch (error) {
      console.error('Error al obtener datos:', err.message);
    }
  };
  const [impPagos, setImpPagos] = useState([]);
  useEffect(()=>{loadImpPagos()},[]);
  //#endregion
  //#region Total Facturado Hoy
  function loadtotfachoy(){
    try {
       fetch(`${process.env.REACT_APP_API_URL}/querysext/8`,
          {method: "post",
          headers: { "Content-Type": "application/json" ,
                    "Authorization":  localStorage.getItem('token'),
                    },
          })
          .then(res => res.json())
          .then(data =>settotfachoy(data));
    } catch (error) {
      console.error('Error al obtener datos:', err.message);
    }
  };
  const [totfachoy, settotfachoy] = useState([]);
  useEffect(()=>{loadtotfachoy()},[]);
  //#endregion
  //#region Card FACTURACION - lado CONSUMO (mes anterior) [CONSULTORIA: 58 -> 91]
  function loadtotrechoy(){
    try {
       fetch(`${process.env.REACT_APP_API_URL}/querysext/91`,
          {method: "post",
          headers: { "Content-Type": "application/json" ,
                    "Authorization":  localStorage.getItem('token'),
                    },
          })
          .then(res => res.json())
          .then(data =>settotrechoy(data));
    } catch (error) {
      console.error('Error al obtener datos:', err.message);
    }
  };
  const [totrechoy, settotrechoy] = useState([]);
  useEffect(()=>{loadtotrechoy()},[]);

  // Estado para el switch de facturación
  // [CONSULTORIA] Por pedido del cliente, el dashboard arranca en VENCIMIENTO.
  const [isFacturacionVencimiento, setisFacturacionVencimiento] = useState(true);

  // Manejador para el cambio de estado del switch
  const handleFacturacionSwitchChange = () => {
    setisFacturacionVencimiento(!isFacturacionVencimiento);
  };

  // Card FACTURACION - lado VENCIMIENTO (mes en curso + siguiente) [CONSULTORIA: 59 -> 92]
  function loadtotfacconsumo(){
    try {
       fetch(`${process.env.REACT_APP_API_URL}/querysext/92`,
          {method: "post",
          headers: { "Content-Type": "application/json" ,
                    "Authorization":  localStorage.getItem('token'),
                    },
          })
          .then(res => res.json())
          .then(data =>settotfacconsumo(data));
    } catch (error) {
      console.error('Error al obtener datos:', err.message);
    }
  };
  const [totfacconsumo, settotfacconsumo] = useState([]);
  useEffect(()=>{loadtotfacconsumo()},[]);
  //#endregion
  //#region recaudado bancos
  function loadTotRecaudadoBancos(){
    try {
       fetch(`${process.env.REACT_APP_API_URL}/querysint/76`,
          {method: "post",
          headers: { "Content-Type": "application/json" ,
                    "Authorization":  localStorage.getItem('token'),
                    },
          })
          .then(res => res.json())
          .then(data =>setTotRecaudadoBancos(data));
    } catch (error) {
      console.error('Error al obtener datos:', err.message);
    }
  };
  const [totRecaudadoBancos, setTotRecaudadoBancos] = useState([]);
  useEffect(()=>{loadTotRecaudadoBancos()},[]);
  //#endregion
  //#region Grafico Batch
  function loadFactuBatch(){
    // Determinar qué endpoint usar basado en el estado del switch
    const endpointId = isFacturacionVencimiento ? "61": "60";

    fetch(`${process.env.REACT_APP_API_URL}/querysext/${endpointId}`,
          {method: "post",
          headers: { "Content-Type": "application/json" ,
                    "Authorization":  localStorage.getItem('token'),
                    },
          body: JSON.stringify({id:"320"})
          })
    .then(res => res.json())
    .then((data) => {
      data = data.qre_resultado;

      const vtasArr = [];
      const optArr = [];
      for (let index = 0; index < data.length; index++) {
        const item = data[index];
        vtasArr.push(item.ImporteTotal);
        optArr.push(item.Mes);
      }
      const barChartData = [
        {
          name: isFacturacionVencimiento ? "Fact. por Vencimiento" : "Fact. por Consumo",
          color: isFacturacionVencimiento ? "#ED8936" : "#2B6CB0",
          data: vtasArr,
        },
      ];
      // etiquetas
      const barChartOptions = {
        chart: {
          toolbar: {
            show: false,
          },
        },
        tooltip: {
          theme: "dark",
        },
        xaxis: {
          categories :optArr,
          labels: {
            style: {
              colors: "#A0AEC0",
              fontSize: "12px",
            },
          },
          show: true,
          axisBorder: {
            show: false,
          },

        },
        yaxis: {
          show: true,
          color: "#A0AEC0",
          labels: {
            show: true,
            style: {
              colors: "#A0AEC0",
              fontSize: "14px",
            },
            formatter: (value) => {
              return moneyFormat(value);
            },
          },
        },
        fill: {
          colors: isFacturacionVencimiento ? "#ED8936" : "#2B6CB0",
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          strokeDashArray: 5,
        },
        plotOptions: {
          bar: {
            borderRadius: 15,
            columnWidth: "15px",
            colors: {
              backgroundBarColors: [],
              backgroundBarRadius: 5,
              backgroundBarOpacity: 1,
              ranges: [],
              fillColor: isFacturacionVencimiento ? "#ED8936" : "#2B6CB0",
            },
          },
        },
        responsive: [
          {
            breakpoint: 768,
            options: {
              plotOptions: {
                bar: {
                  borderRadius: 0,
                },
              },
            },
          },
        ],
      };

      // Limpiar los estados para forzar la actualización completa
      setchartDataBatch([]);
      setchartOptionsBatch({});
      console.log("isFacturacionVencimiento es igual a:", isFacturacionVencimiento);
      // Pequeño retraso para asegurar que React haya limpiado el estado anterior
      setTimeout(() => {
        setchartDataBatch(barChartData);
        setchartOptionsBatch(barChartOptions);
      }, 50);
    });
  };
  const [chartOptionsBatch, setchartOptionsBatch] = useState({});
  const [chartDataBatch, setchartDataBatch] = useState([]);

  // Actualizar el gráfico cuando cambia el estado del switch
  useEffect(() => {
    // Cargar datos iniciales
    loadFactuBatch();
  }, [isFacturacionVencimiento]);
  //#endregion
  //#region Grafico Recaudado
  function loadRecaudacion(){
    fetch(`${process.env.REACT_APP_API_URL}/querysext/16`,
          {
            method: "post",
            headers: { "Content-Type": "application/json" ,
                      "Authorization":  localStorage.getItem('token'),
                    }
    })
    .then(res => res.json())
    .then((data) => {
      data = data.qre_resultado;

      const vtasArr = [];
      const optArr = [];
      for (let index = 0; index < data.length; index++) {
        const item = data[index];
        vtasArr.push(item.ImporteTotal);
        optArr.push(item.Mes);
      }
      const barChartData = [
        {
          name: "Cobrado",
          data: vtasArr,
        },
      ];
      // etiquetas
      const barChartOptions = {
        chart: {
          toolbar: {
            show: false,
          },
        },
        tooltip: {
          theme: "dark",
        },
        xaxis: {
          categories :optArr,
          labels: {
            style: {
              colors: "#A0AEC0",
              fontSize: "12px",
            },
          },
          show: true,
          axisBorder: {
            show: false,
          },

        },
        yaxis: {
          show: true,
          color: "#A0AEC0",
          labels: {
            show: true,
            style: {
              colors: "#A0AEC0",
              fontSize: "14px",
            },
            formatter: (value) => {
              return moneyFormat(value);
            },
          },
        },
        fill: {
          colors: "#ED8936",
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          strokeDashArray: 5,
        },
        plotOptions: {
          bar: {
            borderRadius: 15,
            columnWidth: "15px",
          },
        },
        responsive: [
          {
            breakpoint: 768,
            options: {
              plotOptions: {
                bar: {
                  borderRadius: 0,
                },
              },
            },
          },
        ],
      };

      setchartDataRecauda(barChartData);
      setchartOptionsRecauda(barChartOptions);
    });

  };
  const [chartOptionsRecauda, setchartOptionsRecauda] = useState([]);
  const [chartDataRecauda, setchartDataRecauda] = useState([]);
  useEffect(()=>{loadRecaudacion()},[]);
  //#endregion
  //#region [CONSULTORIA] Vencimientos por dia (77)
  // Modo del grafico de vencimiento dentro de la card de Facturacion Batch:
  // 'meses' = grafico mensual (code 61) | 'dia' = evolucion por dia (code 77)
  const [vtoChartMode, setVtoChartMode] = useState('meses');
  const [chartDataVtoDia, setchartDataVtoDia] = useState([]);
  const [chartOptionsVtoDia, setchartOptionsVtoDia] = useState({});
  function loadVtoPorDia(){
    fetch(`${process.env.REACT_APP_API_URL}/querysext/77`,
      { method: "post",
        headers: { "Content-Type": "application/json",
                   "Authorization": localStorage.getItem('token') } })
    .then(res => res.json())
    .then((data) => {
      const rows = data.qre_resultado || [];
      const importes = [];
      const labels = [];
      rows.forEach((item) => {
        importes.push(item.importe_total);
        const d = new Date(item.fecha_vencimiento);
        labels.push(`${String(d.getUTCDate()).padStart(2,'0')}/${String(d.getUTCMonth()+1).padStart(2,'0')}`);
      });
      setchartDataVtoDia([{ name: "Vence por día", color: "#ED8936", data: importes }]);
      setchartOptionsVtoDia({
        chart: { toolbar: { show: false } },
        tooltip: { theme: "dark", y: { formatter: (v) => moneyFormat(v) } },
        xaxis: {
          categories: labels,
          labels: { style: { colors: "#A0AEC0", fontSize: "11px" } },
          axisBorder: { show: false },
        },
        yaxis: { labels: { style: { colors: "#A0AEC0", fontSize: "12px" },
                           formatter: (v) => moneyFormat(v) } },
        fill: { colors: ["#ED8936"] },
        dataLabels: { enabled: false },
        grid: { strokeDashArray: 5 },
        plotOptions: { bar: { borderRadius: 6, columnWidth: "60%" } },
      });
    })
    .catch((e) => console.error('Error vto por dia:', e));
  };
  useEffect(()=>{loadVtoPorDia()},[]);
  //#endregion
  //#region [CONSULTORIA] Facturado 12m + kW (78) y Suministros 12m (79)
  const [fac12m, setFac12m] = useState([]);
  function loadFac12m(){
    fetch(`${process.env.REACT_APP_API_URL}/querysext/78`,
      { method: "post",
        headers: { "Content-Type": "application/json",
                   "Authorization": localStorage.getItem('token') } })
    .then(res => res.json()).then(d => setFac12m(d))
    .catch((e) => console.error('Error fac 12m:', e));
  };
  useEffect(()=>{loadFac12m()},[]);

  const [sumin12m, setSumin12m] = useState([]);
  function loadSumin12m(){
    fetch(`${process.env.REACT_APP_API_URL}/querysext/79`,
      { method: "post",
        headers: { "Content-Type": "application/json",
                   "Authorization": localStorage.getItem('token') } })
    .then(res => res.json()).then(d => setSumin12m(d))
    .catch((e) => console.error('Error suministros 12m:', e));
  };
  useEffect(()=>{loadSumin12m()},[]);
  //#endregion

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', pt: '120px' }}>
      {/* 4 KPI cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        {/* FACTURACION */}
        <Grid item xs={12} sm={6} xl={3}>
          <Card sx={{ minHeight: 125 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                <Box sx={{ flex: 1, mr: 'auto' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="caption" color="text.secondary" fontWeight="bold" textTransform="uppercase">
                      FACTURACION {isFacturacionVencimiento ? "(VENCIMIENTO)" : "(CONSUMO)"}
                    </Typography>
                    <Switch
                      size="small"
                      checked={isFacturacionVencimiento}
                      onChange={handleFacturacionSwitchChange}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </Box>
                  <Box component={ReactRouterLink} to="/admin/batch" sx={{ textDecoration: 'none', display: 'block' }}>
                    <Typography variant="h6" fontWeight="bold" color="text.primary">
                      <Tooltip title={
                        isFacturacionVencimiento
                          ? (totfacconsumo.qre_resultado ? moneyFormat(totfacconsumo.qre_resultado[0].recaudado) : '0')
                          : (totrechoy.qre_resultado ? moneyFormat(totrechoy.qre_resultado[0].recaudado) : '0')
                      } placement="top">
                        <span>
                          {isFacturacionVencimiento
                            ? fmtM(totfacconsumo.qre_resultado?.[0]?.recaudado)
                            : fmtM(totrechoy.qre_resultado?.[0]?.recaudado)}
                        </span>
                      </Tooltip>
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                      {!isFacturacionVencimiento
                        ? `Facturado por consumo · ${getPreviousMonthName()} (último mes cerrado)`
                        : `Facturado con vencimiento · ${getMonthName()} a ${getNextMonthName()}`
                      }
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ borderRadius: '50%', width: 45, height: 45, bgcolor: iconGreen, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <ReceiptLongIcon sx={{ color: '#fff', fontSize: 24 }} />
                </Box>
              </Box>
            </Box>
          </Card>
        </Grid>

        {/* COBRANZA */}
        <Grid item xs={12} sm={6} xl={3}>
          <Box component={ReactRouterLink} to="/admin/cobranzas" sx={{ textDecoration: 'none', display: 'block' }}>
            <Card sx={{ minHeight: 125 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  <Box sx={{ flex: 1, mr: 'auto' }}>
                    <Typography variant="caption" color="text.secondary" fontWeight="bold" textTransform="uppercase">
                      COBRANZA
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" color="text.primary">
                      <Tooltip title={totfachoy.qre_resultado ? moneyFormat(totfachoy.qre_resultado[0].ImporteFacturado) : '0'} placement="top">
                        <span>{fmtM(totfachoy.qre_resultado?.[0]?.ImporteFacturado)}</span>
                      </Tooltip>
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                      Cobranza cerrada al mes de {getPreviousMonthName()}
                    </Typography>
                  </Box>
                  <Box sx={{ borderRadius: '50%', width: 45, height: 45, bgcolor: iconGreen, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <AccountBalanceWalletIcon sx={{ color: '#fff', fontSize: 24 }} />
                  </Box>
                </Box>
              </Box>
            </Card>
          </Box>
        </Grid>

        {/* RECAUDACION */}
        <Grid item xs={12} sm={6} xl={3}>
          <Box component={ReactRouterLink} to="/admin/presupuesto_financiero" sx={{ textDecoration: 'none', display: 'block' }}>
            <Card sx={{ minHeight: 125 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  <Box sx={{ flex: 1, mr: 'auto' }}>
                    <Typography variant="caption" color="text.secondary" fontWeight="bold" textTransform="uppercase">
                      RECAUDACION
                    </Typography>
                    <Typography variant="h6" fontWeight="bold" color="text.secondary">
                      En desarrollo
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                      Próximamente
                    </Typography>
                  </Box>
                  <Box sx={{ borderRadius: '50%', width: 45, height: 45, bgcolor: iconGreen, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <PriceCheckIcon sx={{ color: '#fff', fontSize: 24 }} />
                  </Box>
                </Box>
              </Box>
            </Card>
          </Box>
        </Grid>

        {/* DEUDA */}
        <Grid item xs={12} sm={6} xl={3}>
          <Card
            sx={{ minHeight: 125, cursor: 'pointer', transition: 'box-shadow .15s',
              '&:hover': { boxShadow: '0 4px 16px rgba(0,0,0,.13)' } }}
            onClick={() => history.push('/admin/deudapor-tipo')}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>

              {/* Fila superior: valor + ícono */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" color="text.secondary" fontWeight="bold" textTransform="uppercase">
                    DEUDA
                  </Typography>
                  <Typography variant="h6" fontWeight="bold" color="text.primary">
                    <Tooltip title={impDeuda != null ? moneyFormat(impDeuda) : '—'} placement="top">
                        <span>
                          {loadingDeuda
                            ? '...'
                            : impDeuda != null
                              ? `$${(impDeuda / 1e6).toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}M`
                              : '—'
                          }
                        </span>
                      </Tooltip>
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.72rem' }}>
                    Total sin Municipalidad · sin mes actual
                  </Typography>
                </Box>
                <Box sx={{ borderRadius: '50%', width: 45, height: 45, bgcolor: iconGreen,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <WarningAmberIcon sx={{ color: '#fff', fontSize: 24 }} />
                </Box>
              </Box>

              {/* Toggle filtro de fecha */}
              <ToggleButtonGroup
                value={filtroDeuda}
                exclusive
                onChange={(e, v) => { e.stopPropagation(); if (v) setFiltroDeuda(v); }}
                size="small"
                fullWidth
                sx={{ mt: 0.5 }}
              >
                <ToggleButton value="periodo" sx={{
                  fontSize: '0.65rem', fontWeight: 600, py: 0.3, flex: 1,
                  '&.Mui-selected': { bgcolor: '#8ebf63', color: '#fff', '&:hover': { bgcolor: '#39a82d' } },
                }}>
                  Por Período
                </ToggleButton>
                <ToggleButton value="compvto" sx={{
                  fontSize: '0.65rem', fontWeight: 600, py: 0.3, flex: 1,
                  '&.Mui-selected': { bgcolor: '#8ebf63', color: '#fff', '&:hover': { bgcolor: '#39a82d' } },
                }}>
                  Por Vencimiento
                </ToggleButton>
              </ToggleButtonGroup>

            </Box>
          </Card>
        </Grid>
      </Grid>

      {/* 2 Chart cards */}
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12} lg={6}>
          <Card sx={{ p: 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', mb: 5, pt: '28px', px: '22px', flexWrap: 'wrap', gap: 1 }}>
              <Link component={ReactRouterLink} to="/admin/batch" sx={{ fontSize: '1.125rem', fontWeight: 'bold', textDecoration: 'none' }}>
                {isFacturacionVencimiento ? 'Facturación por Vencimiento' : 'Facturación por Consumo'} <OpenInNewIcon sx={{ fontSize: 16, ml: 0.5 }} />
              </Link>
              {/* [CONSULTORIA] Toggle secundario: solo visible en modo Vencimiento */}
              {isFacturacionVencimiento && (
                <ToggleButtonGroup
                  value={vtoChartMode}
                  exclusive
                  size="small"
                  onChange={(e, v) => { if (v) setVtoChartMode(v); }}
                >
                  <ToggleButton value="meses" sx={{ fontSize: '0.7rem', fontWeight: 600, py: 0.3, px: 1.2,
                    '&.Mui-selected': { bgcolor: '#8ebf63', color: '#fff', '&:hover': { bgcolor: '#39a82d' } } }}>
                    Por mes
                  </ToggleButton>
                  <ToggleButton value="dia" sx={{ fontSize: '0.7rem', fontWeight: 600, py: 0.3, px: 1.2,
                    '&.Mui-selected': { bgcolor: '#8ebf63', color: '#fff', '&:hover': { bgcolor: '#39a82d' } } }}>
                    Evolución por día
                  </ToggleButton>
                </ToggleButtonGroup>
              )}
            </Box>
            <Box sx={{ minHeight: 300 }}>
              <BarChart
                chartData={isFacturacionVencimiento && vtoChartMode === 'dia' ? chartDataVtoDia : chartDataBatch}
                chartOptions={isFacturacionVencimiento && vtoChartMode === 'dia' ? chartOptionsVtoDia : chartOptionsBatch}
              />
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12} lg={6}>
          <Card sx={{ p: 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', mb: 5, pt: '28px', pl: '22px' }}>
              <Link component={ReactRouterLink} to="/admin/cobranzas" sx={{ fontSize: '1.125rem', fontWeight: 'bold', textDecoration: 'none' }}>
                Cobrado <OpenInNewIcon sx={{ fontSize: 16, ml: 0.5 }} />
              </Link>
            </Box>
            <Box sx={{ minHeight: 300 }}>
              <BarChart chartData={chartDataRecauda} chartOptions={chartOptionsRecauda} />
            </Box>
          </Card>
        </Grid>
      </Grid>

      {/* [CONSULTORIA] Tarjetas inferiores (4): Facturado 12m ($ y kW), Sum. Energía, Sum. Sepelio */}
      <Grid container spacing={3} sx={{ mt: 1, mb: 3 }}>
        {/* Facturado $ ultimos 12 meses */}
        <Grid item xs={12} sm={6} xl={3}>
          <Card sx={{ minHeight: 125 }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
              <Box sx={{ flex: 1, mr: 'auto' }}>
                <Typography variant="caption" color="text.secondary" fontWeight="bold" textTransform="uppercase">
                  Facturado últimos 12 meses
                </Typography>
                <Typography variant="h6" fontWeight="bold" color="text.primary">
                  <Tooltip title={fac12m.qre_resultado ? moneyFormat(fac12m.qre_resultado[0].importe_total) : '0'} placement="top">
                    <span>{fmtM(fac12m.qre_resultado?.[0]?.importe_total)}</span>
                  </Tooltip>
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                  Importe facturado por consumo (12 meses)
                </Typography>
              </Box>
              <Box sx={{ borderRadius: '50%', width: 45, height: 45, bgcolor: iconGreen, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <ReceiptLongIcon sx={{ color: '#fff', fontSize: 24 }} />
              </Box>
            </Box>
          </Card>
        </Grid>

        {/* Facturado kW ultimos 12 meses */}
        <Grid item xs={12} sm={6} xl={3}>
          <Card sx={{ minHeight: 125 }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
              <Box sx={{ flex: 1, mr: 'auto' }}>
                <Typography variant="caption" color="text.secondary" fontWeight="bold" textTransform="uppercase">
                  Facturado kW (12 meses)
                </Typography>
                <Typography variant="h6" fontWeight="bold" color="text.primary">
                  <Tooltip title={fac12m.qre_resultado ? `${fmtNum(fac12m.qre_resultado[0].kw_total)} kWh` : '0'} placement="top">
                    <span>{fmtKw(fac12m.qre_resultado?.[0]?.kw_total)}</span>
                  </Tooltip>
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                  Energía facturada por consumo (12 meses)
                </Typography>
              </Box>
              <Box sx={{ borderRadius: '50%', width: 45, height: 45, bgcolor: iconGreen, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <BoltIcon sx={{ color: '#fff', fontSize: 24 }} />
              </Box>
            </Box>
          </Card>
        </Grid>

        {/* Total Sum. Energia */}
        <Grid item xs={12} sm={6} xl={3}>
          <Card sx={{ minHeight: 125 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                <Box sx={{ flex: 1, mr: 'auto' }}>
                  <Typography variant="caption" color="text.secondary" fontWeight="bold" textTransform="uppercase">
                    Total Sum. Energia
                  </Typography>
                  <Typography variant="h6" fontWeight="bold" color="text.primary">
                    {TotSE.qre_resultado ? TotSE.qre_resultado[0].cantidad : "0"}
                  </Typography>
                </Box>
                <Box sx={{ borderRadius: '50%', width: 45, height: 45, bgcolor: iconGrey, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <BoltIcon sx={{ color: '#fff', fontSize: 24 }} />
                </Box>
              </Box>
            </Box>
          </Card>
        </Grid>

        {/* Total Sum. Sepelio */}
        <Grid item xs={12} sm={6} xl={3}>
          <Card sx={{ minHeight: 125 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                <Box sx={{ flex: 1, mr: 'auto' }}>
                  <Typography variant="caption" color="text.secondary" fontWeight="bold" textTransform="uppercase">
                    Total Sum. Sepelio
                  </Typography>
                  <Typography variant="h6" fontWeight="bold" color="text.primary">
                    {TotSS.qre_resultado ? TotSS.qre_resultado[0].cantidad : "0"}
                  </Typography>
                </Box>
                <Box sx={{ borderRadius: '50%', width: 45, height: 45, bgcolor: iconGrey, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <LocalFloristIcon sx={{ color: '#fff', fontSize: 24 }} />
                </Box>
              </Box>
            </Box>
          </Card>
        </Grid>
      </Grid>

    </Box>
  );
}
